var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _g, _path16, _mask, _path17, _path18, _path19, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 40,
    viewBox: "0 0 132 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83984 26.3947C5.83984 26.3947 6.53235 19.4346 14.0122 15.3376C14.0122 15.3376 22.8034 10.0141 22.5044 5.33398C22.5044 5.33398 26.3957 10.8673 21.453 16.5835C21.453 16.5835 18.6687 19.9432 13.8438 20.8861C13.8438 20.8861 9.15002 21.4891 5.83984 26.3947Z",
    fill: "url(#paint0_linear_1_21)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3359 23.4369C10.3359 23.4369 16.4095 20.1104 23.9544 24.0831C23.9544 24.0831 33.2371 28.4671 36.8916 25.5889C36.8916 25.5889 34.5566 31.9586 27.1137 31.0222C27.1137 31.0222 22.8068 30.5731 19.3277 27.0564C19.3277 27.0564 16.2013 23.4591 10.3359 23.4369Z",
    fill: "url(#paint1_linear_1_21)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.93555 25.8743C5.93555 25.8743 7.14104 18.9865 14.9023 15.469C14.9023 15.469 24.0627 10.8284 24.1106 6.13867C24.1106 6.13867 27.582 11.9517 22.2304 17.2765C22.2304 17.2765 19.2051 20.4151 14.3239 20.9888C14.3239 20.9888 9.5998 21.2336 5.93555 25.8743Z",
    fill: "url(#paint2_linear_1_21)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6387 23.2662C10.6387 23.2662 16.9407 20.4107 24.1704 24.945C24.1704 24.945 33.1027 30.0212 36.9602 27.429C36.9602 27.429 34.1607 33.6032 26.8081 32.1046C26.8081 32.1046 22.5464 31.3295 19.3375 27.5582C19.3375 27.5582 16.4856 23.734 10.6387 23.2662Z",
    fill: "url(#paint3_linear_1_21)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6937 29.3913C15.6937 32.305 13.3624 34.6669 10.4869 34.6669C7.61133 34.6669 5.28027 32.305 5.28027 29.3913C5.28027 26.4772 7.61133 24.1152 10.4869 24.1152C13.3624 24.1152 15.6937 26.4772 15.6937 29.3913Z",
    fill: "url(#paint4_linear_1_21)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8429 22.1809C39.6149 22.062 39.5996 21.994 39.5996 21.5353C39.5996 20.6874 39.6655 20.0084 39.68 19.7363C39.6969 19.5504 39.7295 19.4651 39.8102 19.4651C39.9072 19.4651 39.9236 19.5159 39.9236 19.6523C39.9236 19.8046 39.9236 20.0432 39.9731 20.2798C40.2156 21.5356 41.285 22.0112 42.3693 22.0112C43.9255 22.0112 44.6851 20.8401 44.6851 19.7538C44.6851 18.5833 44.2165 17.9045 42.8232 16.6992L42.0937 16.0706C40.3772 14.594 39.9892 13.5417 39.9892 12.3884C39.9892 10.5735 41.2847 9.33398 43.3417 9.33398C43.973 9.33398 44.4424 9.40197 44.8467 9.50357C45.1551 9.572 45.285 9.58828 45.4134 9.58828C45.5447 9.58828 45.5761 9.62279 45.5761 9.70706C45.5761 9.79163 45.512 10.3525 45.512 11.5055C45.512 11.7776 45.4791 11.8965 45.3984 11.8965C45.3014 11.8965 45.285 11.8121 45.2685 11.6762C45.2521 11.473 45.1551 11.015 45.0581 10.8269C44.9612 10.6406 44.523 9.92775 43.0332 9.92775C41.916 9.92775 41.0414 10.6579 41.0414 11.8965C41.0414 12.8632 41.4621 13.4746 43.0174 14.748L43.4706 15.1214C45.3818 16.6992 45.8355 17.7512 45.8355 19.1086C45.8355 19.8049 45.5758 21.0943 44.4582 21.9261C43.7621 22.436 42.8867 22.6392 42.0127 22.6392C41.2512 22.6392 40.5071 22.5201 39.8429 22.1809Z",
    fill: "url(#paint5_linear_1_21)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2483 11.2168C52.1519 11.2168 52.0871 11.3008 51.9092 11.7763L48.557 20.8055C48.2818 21.5347 48.0053 22.0442 47.3576 22.1284C47.2457 22.1458 47.0339 22.1629 46.9375 22.1629C46.8726 22.1629 46.8076 22.2137 46.8076 22.2817C46.8076 22.3664 46.9056 22.4005 47.083 22.4005C47.471 22.4005 47.9178 22.378 48.2158 22.3629C48.3646 22.3555 48.4763 22.3499 48.5248 22.3499C48.5905 22.3499 48.7586 22.3583 48.9578 22.3682C49.2473 22.3827 49.6022 22.4005 49.8039 22.4005C49.9339 22.4005 50.0151 22.3664 50.0151 22.2817C50.0151 22.2137 49.9816 22.1629 49.8682 22.1629H49.7389C49.4963 22.1629 49.253 22.0613 49.253 21.7717C49.253 21.5175 49.3335 21.162 49.4634 20.8055L50.2742 18.4973C50.305 18.4127 50.3553 18.3782 50.4202 18.3782H53.7068C53.7883 18.3782 53.8041 18.3957 53.8367 18.4628L55.1159 21.7721C55.2127 22.0108 55.0682 22.1287 54.9875 22.1632C54.9756 22.1693 54.9648 22.1744 54.955 22.1788C54.9109 22.1991 54.889 22.2092 54.889 22.2649C54.889 22.3392 55.0624 22.3485 55.2906 22.3607C55.3234 22.3624 55.3573 22.3644 55.3919 22.3664C56.3798 22.4005 57.4325 22.4005 57.6428 22.4005C57.8038 22.4005 57.9665 22.3664 57.9665 22.2817C57.9665 22.1966 57.8696 22.1629 57.7891 22.1629C57.6428 22.1629 57.4325 22.1458 57.2219 22.0784C56.9133 21.9757 56.5247 21.7887 56.0068 20.4996C55.5531 19.3642 54.7201 17.2148 53.9871 15.3237C53.3072 13.5692 52.7134 12.0369 52.5884 11.7429C52.5597 11.6787 52.5347 11.6195 52.5121 11.5654C52.4202 11.3473 52.3654 11.2168 52.2483 11.2168ZM53.545 17.682C53.56 17.75 53.56 17.7834 53.4959 17.7834H50.6123C50.5644 17.7834 50.548 17.75 50.5644 17.682L51.8928 13.7284C51.9743 13.508 52.0553 13.508 52.1361 13.7284L53.545 17.682Z",
    fill: "url(#paint6_linear_1_21)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8911 20.5504C70.9395 21.0601 71.0371 21.8408 71.6193 22.0443C72.0253 22.1802 72.3972 22.1802 72.5435 22.1802C72.6085 22.1802 72.6569 22.2138 72.6569 22.2818C72.6569 22.3665 72.5271 22.4179 72.3658 22.4179C72.0421 22.4179 70.4536 22.4006 69.9356 22.3498C69.5955 22.3163 69.5297 22.2649 69.5297 22.1968C69.5297 22.1461 69.5626 22.094 69.6275 22.0786C69.7089 22.0614 69.7253 21.8411 69.6928 21.5687L69.013 14.2369H68.9801L65.5462 21.603C65.2551 22.231 65.1746 22.3665 65.0448 22.3665C64.9146 22.3665 64.8345 22.231 64.558 21.7049C64.1866 20.9921 63.2459 19.1422 62.8908 18.3613C62.4692 17.4446 61.3191 15.0185 61.0758 14.4247H61.0118L60.4601 20.9416C60.4443 21.162 60.4443 21.4326 60.4443 21.6712C60.4443 21.8905 60.5745 22.0269 60.7848 22.0786C61.0265 22.1462 61.2387 22.1633 61.3355 22.1633C61.3831 22.1633 61.4493 22.2141 61.4493 22.2649C61.4493 22.3665 61.3523 22.4009 61.1892 22.4009C60.6552 22.4009 59.9751 22.3501 59.8617 22.3501C59.7307 22.3501 59.0518 22.4009 58.6631 22.4009C58.5168 22.4009 58.4189 22.3668 58.4189 22.2649C58.4189 22.2141 58.4848 22.1633 58.5652 22.1633C58.6788 22.1633 58.7756 22.1461 58.9859 22.1116C59.4563 22.0269 59.4727 21.5008 59.5376 20.9589L60.5745 11.5395C60.5909 11.3871 60.6552 11.2852 60.7353 11.2852C60.8333 11.2852 60.9475 11.336 61.0265 11.5047L65.3358 20.466L69.4822 11.5221C69.5465 11.3868 69.6114 11.2852 69.7092 11.2852C69.8062 11.2852 69.8869 11.4031 69.9195 11.6751L70.8911 20.5504Z",
    fill: "url(#paint7_linear_1_21)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3071 20.5167C79.1343 18.5832 80.9968 13.6616 81.3044 12.6268C81.3697 12.4058 81.4345 12.2014 81.4345 12.0835C81.4345 11.9647 81.3861 11.8292 81.2406 11.7775C81.0779 11.7267 80.9161 11.7267 80.7539 11.7267C80.6733 11.7267 80.5921 11.6759 80.5921 11.6079C80.5921 11.5231 80.6889 11.4883 80.9161 11.4883C81.4825 11.4883 82.1317 11.5226 82.3091 11.5226C82.389 11.5226 83.0053 11.4883 83.4272 11.4883C83.5717 11.4883 83.6534 11.5226 83.6534 11.5908C83.6534 11.6588 83.6049 11.7267 83.4912 11.7267C83.3943 11.7267 83.0706 11.7267 82.8109 11.8963C82.617 12.0327 82.389 12.2359 82.0176 13.2197C81.8555 13.6281 81.1602 15.3583 80.4292 17.1232C79.5552 19.2284 78.9239 20.7893 78.6002 21.5015C78.2122 22.3673 78.1302 22.5877 77.9845 22.5877C77.8224 22.5877 77.7254 22.4014 77.4502 21.7059L73.9522 12.8635C73.6285 12.0503 73.4328 11.8968 72.9639 11.7778C72.7363 11.727 72.4939 11.727 72.4132 11.727C72.3326 11.727 72.2998 11.6422 72.2998 11.5911C72.2998 11.5058 72.4443 11.4886 72.6728 11.4886C73.352 11.4886 74.162 11.5231 74.34 11.5231C74.4854 11.5231 75.1178 11.4886 75.6684 11.4886C75.9281 11.4886 76.0564 11.5231 76.0564 11.5911C76.0564 11.659 76.0089 11.727 75.912 11.727C75.7491 11.727 75.5221 11.7444 75.3922 11.7952C75.2477 11.8626 75.2312 11.9474 75.2312 12.0503C75.2312 12.2362 75.409 12.6773 75.6194 13.2542L78.3071 20.5167Z",
    fill: "url(#paint8_linear_1_21)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7587 15.6649C85.7587 13.4248 85.7587 13.0172 85.7258 12.5592C85.6947 12.0674 85.6133 11.8304 85.1438 11.7622C85.0305 11.7448 84.7872 11.7277 84.6583 11.7277C84.6088 11.7277 84.5439 11.6598 84.5439 11.609C84.5439 11.5241 84.6088 11.4893 84.7708 11.4893C85.4185 11.4893 86.3427 11.5236 86.423 11.5236C86.5199 11.5236 89.5008 11.541 89.8248 11.5236C90.0992 11.5062 90.3583 11.4563 90.4708 11.4391C90.5367 11.4219 90.6021 11.3711 90.6664 11.3711C90.7141 11.3711 90.7305 11.4391 90.7305 11.5062C90.7305 11.6087 90.6497 11.7782 90.6189 12.1849C90.6021 12.3212 90.5695 12.9661 90.5367 13.1356C90.5211 13.205 90.4708 13.288 90.4068 13.288C90.3259 13.288 90.2931 13.2201 90.2931 13.1019C90.2931 12.9997 90.2766 12.7636 90.2125 12.593C90.1156 12.3554 89.9693 12.2538 89.1922 12.1522C88.9497 12.1179 87.2975 12.1002 87.1347 12.1002C87.0704 12.1002 87.054 12.1522 87.054 12.2538V16.1738C87.054 16.2743 87.054 16.326 87.1347 16.326C87.3139 16.326 89.1922 16.326 89.5164 16.2917C89.8565 16.2591 90.0662 16.2417 90.2125 16.0885C90.3095 15.9869 90.3744 15.9026 90.4229 15.9026C90.4705 15.9026 90.504 15.9352 90.504 16.0214C90.504 16.1061 90.4229 16.3433 90.3897 16.8189C90.358 17.1076 90.3256 17.6508 90.3256 17.7518C90.3256 17.8706 90.2927 18.023 90.1964 18.023C90.1315 18.023 90.0986 17.9731 90.0986 17.8877C90.0986 17.7516 90.0986 17.5992 90.0346 17.4124C89.9852 17.2092 89.8559 17.0393 89.3048 16.9722C88.9167 16.9205 87.3941 16.9029 87.1509 16.9029C87.0701 16.9029 87.054 16.9549 87.054 17.0045V18.2098C87.054 18.7033 87.0374 20.3815 87.054 20.6707C87.0869 21.6379 87.3469 21.8251 88.7549 21.8251C89.1274 21.8251 89.8081 21.8251 90.1806 21.6727C90.5528 21.5022 90.747 21.2482 90.8283 20.671C90.8604 20.5015 90.8933 20.4507 90.9737 20.4507C91.0542 20.4507 91.0707 20.5694 91.0707 20.671C91.0707 20.7726 90.9573 21.7564 90.8768 22.0629C90.7798 22.4366 90.6335 22.4366 90.0828 22.4366C89.0143 22.4366 88.1888 22.4021 87.6051 22.3849C87.0066 22.3515 86.6326 22.3515 86.423 22.3515C86.3903 22.3515 86.1148 22.3515 85.8072 22.368C85.5316 22.3852 85.2079 22.4021 84.9807 22.4021C84.8348 22.4021 84.754 22.3681 84.754 22.2833C84.754 22.2325 84.7866 22.1646 84.8674 22.1646C84.9967 22.1646 85.1747 22.1129 85.3049 22.0952C85.5801 22.0458 85.613 21.7561 85.6779 21.3329C85.7587 20.7378 85.7587 19.602 85.7587 18.2098V15.6649Z",
    fill: "url(#paint9_linear_1_21)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6498 12.5587C94.6827 13.0166 94.6827 13.4242 94.6827 15.6643L94.683 18.2092C94.683 19.6014 94.683 20.7373 94.6007 21.3322C94.5989 21.3448 94.5971 21.3572 94.5951 21.3697C94.5346 21.7715 94.4957 22.0297 94.2296 22.0947C94.1002 22.1295 93.922 22.164 93.7921 22.164C93.7113 22.164 93.6784 22.232 93.6784 22.2828C93.6784 22.3675 93.7601 22.4016 93.9054 22.4016C94.1316 22.4016 94.4715 22.3847 94.7636 22.3675C94.9834 22.3675 95.1848 22.358 95.2839 22.3533C95.3164 22.3518 95.3379 22.3507 95.3455 22.3507C95.412 22.3507 95.8978 22.3844 96.5127 22.4361C96.6319 22.4424 96.7565 22.4495 96.8845 22.4568C97.4179 22.487 98.0087 22.5205 98.5054 22.5205C100.934 22.5205 102.213 21.5185 102.83 20.8574C103.623 20.0087 104.368 18.6171 104.368 16.801C104.368 15.0876 103.688 13.8815 102.975 13.1354C101.396 11.4659 99.0068 11.4794 97.5396 11.4875C97.4414 11.4881 97.3474 11.4887 97.2579 11.4887C96.6724 11.4887 96.056 11.5053 95.6796 11.5155C95.5142 11.52 95.3952 11.5231 95.3455 11.5231C95.3245 11.5231 95.2463 11.5209 95.1308 11.5173C94.8029 11.5075 94.1737 11.4887 93.6948 11.4887C93.5335 11.4887 93.4668 11.5234 93.4668 11.6084C93.4668 11.6592 93.5335 11.7272 93.5812 11.7272C93.7109 11.7272 93.9528 11.7442 94.0661 11.7617C94.5364 11.8297 94.6178 12.0668 94.6498 12.5587ZM95.9951 20.3655C95.9785 20.093 95.9785 18.7529 95.9785 17.2249L95.9782 12.406C95.9782 12.2361 96.0259 12.167 96.1556 12.1173C96.2855 12.0665 96.7394 12.0157 97.0149 12.0157C98.715 12.0157 100.287 12.2016 101.63 13.6283C102.213 14.238 102.975 15.4093 102.975 17.2422C102.975 18.5663 102.603 19.941 101.858 20.6705C100.999 21.5188 99.8331 21.9772 98.5221 21.9772C96.8367 21.9772 96.3337 21.6721 96.1561 21.4009C96.0435 21.2473 96.0101 20.7223 95.9951 20.3655Z",
    fill: "url(#paint10_linear_1_21)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.239 20.4332C108.272 21.621 108.4 21.9778 108.79 22.0803C109.048 22.1476 109.373 22.1648 109.503 22.1648C109.567 22.1648 109.617 22.2156 109.617 22.2836C109.617 22.3683 109.518 22.4025 109.357 22.4025C108.547 22.4025 107.981 22.3517 107.85 22.3517C107.721 22.3517 107.121 22.4025 106.473 22.4025C106.328 22.4025 106.246 22.3852 106.246 22.2836C106.246 22.2156 106.296 22.1648 106.36 22.1648C106.473 22.1648 106.733 22.1476 106.943 22.0803C107.299 21.9778 107.348 21.5874 107.348 20.2808V12.0165C107.348 11.4394 107.429 11.2871 107.543 11.2871C107.705 11.2871 107.948 11.5755 108.092 11.7279C108.32 11.9657 110.393 14.2731 112.596 16.6487C114.005 18.1766 115.528 19.8908 115.965 20.3661L115.819 13.1361C115.804 12.2021 115.723 11.8801 115.284 11.7959C115.025 11.7451 114.701 11.7279 114.589 11.7279C114.491 11.7279 114.476 11.6429 114.476 11.5918C114.476 11.5064 114.589 11.4893 114.75 11.4893C115.398 11.4893 116.078 11.5238 116.24 11.5238C116.403 11.5238 116.873 11.4893 117.455 11.4893C117.601 11.4893 117.715 11.5064 117.715 11.5918C117.715 11.6426 117.65 11.7279 117.552 11.7279C117.488 11.7279 117.374 11.7279 117.212 11.7622C116.743 11.8629 116.71 12.1526 116.71 13.0171L116.678 21.4686C116.678 22.4194 116.661 22.504 116.564 22.504C116.419 22.504 116.273 22.3852 115.479 21.6213C115.334 21.4852 113.277 19.3658 111.77 17.7187C110.118 15.9032 108.515 14.1379 108.077 13.6291L108.239 20.4332Z",
    fill: "url(#paint11_linear_1_21)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.641 11.2168C123.544 11.2168 123.479 11.3008 123.301 11.7763L119.951 20.8055C119.675 21.5347 119.4 22.0442 118.751 22.1284C118.639 22.1458 118.427 22.1629 118.33 22.1629C118.265 22.1629 118.2 22.2137 118.2 22.2817C118.2 22.3664 118.297 22.4005 118.475 22.4005C118.864 22.4005 119.311 22.378 119.609 22.3629C119.757 22.3555 119.869 22.3499 119.917 22.3499C119.984 22.3499 120.152 22.3583 120.352 22.3682C120.641 22.3827 120.995 22.4005 121.196 22.4005C121.326 22.4005 121.407 22.3664 121.407 22.2817C121.407 22.2137 121.375 22.1629 121.262 22.1629H121.131C120.889 22.1629 120.646 22.0613 120.646 21.7717C120.646 21.5175 120.727 21.162 120.856 20.8055L121.667 18.4973C121.698 18.4127 121.746 18.3782 121.812 18.3782H125.099C125.181 18.3782 125.198 18.3957 125.23 18.4628L126.509 21.7721C126.606 22.0108 126.461 22.1287 126.379 22.1632C126.368 22.1692 126.357 22.1739 126.348 22.1783C126.303 22.1989 126.282 22.2087 126.282 22.2649C126.282 22.3391 126.456 22.3484 126.683 22.3607C126.715 22.3624 126.749 22.3644 126.784 22.3664C127.772 22.4005 128.826 22.4005 129.035 22.4005C129.197 22.4005 129.359 22.3664 129.359 22.2817C129.359 22.1966 129.262 22.1629 129.181 22.1629C129.035 22.1629 128.826 22.1458 128.613 22.0784C128.306 21.9757 127.918 21.7887 127.4 20.4996C126.946 19.3642 126.113 17.2148 125.38 15.3237C124.7 13.5692 124.107 12.0369 123.982 11.7429C123.952 11.6777 123.927 11.6174 123.904 11.5626C123.812 11.3462 123.758 11.2168 123.641 11.2168ZM124.938 17.682C124.953 17.75 124.953 17.7834 124.889 17.7834H122.005C121.958 17.7834 121.941 17.75 121.958 17.682L123.286 13.7284C123.365 13.508 123.448 13.508 123.529 13.7284L124.938 17.682Z",
    fill: "url(#paint12_linear_1_21)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M116.604 26.8464C116.236 26.8464 115.95 27.0353 115.746 27.4143C115.543 27.7462 115.442 28.1613 115.442 28.661C115.442 29.0691 115.557 29.4222 115.786 29.7203C116.014 30.019 116.318 30.1682 116.697 30.1682C117.127 30.1682 117.465 30.0115 117.712 29.6981C117.82 29.5704 117.908 29.5067 117.977 29.5067C118.064 29.5067 118.109 29.5575 118.109 29.6585C118.109 29.8031 118.003 29.9719 117.793 30.1682C117.449 30.5014 117.048 30.6679 116.591 30.6679C116.222 30.6679 115.902 30.5802 115.627 30.4025C115.353 30.2262 115.145 29.9831 114.999 29.6729C114.853 29.3638 114.78 29.0174 114.78 28.6344C114.78 28.2406 114.865 27.8739 115.032 27.5328C115.2 27.1932 115.436 26.923 115.741 26.7195C116.045 26.5185 116.389 26.418 116.774 26.418C117.107 26.418 117.407 26.5145 117.673 26.7091C117.892 26.8641 118.003 27.0399 118.003 27.2366C118.003 27.3149 117.974 27.3894 117.916 27.4603C117.86 27.5311 117.796 27.5673 117.725 27.5673C117.639 27.5673 117.581 27.5534 117.553 27.5258C117.523 27.4999 117.463 27.4258 117.37 27.3065C117.242 27.14 117.127 27.0221 117.027 26.9522C116.928 26.8807 116.786 26.8464 116.604 26.8464Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.872 30.0289C121.838 29.9472 121.821 29.7678 121.821 29.4913V28.1047C121.821 27.5382 121.644 27.1135 121.291 26.831C120.957 26.5545 120.549 26.416 120.063 26.416C119.696 26.416 119.36 26.4953 119.057 26.6527C118.836 26.7536 118.728 26.8743 118.728 27.0138C118.728 27.1608 118.807 27.2342 118.967 27.2342C119.015 27.2342 119.132 27.1794 119.322 27.069C119.573 26.911 119.82 26.831 120.063 26.831C120.362 26.831 120.621 26.927 120.84 27.117C121.061 27.3066 121.179 27.5584 121.198 27.8681L120.695 27.8424C120.102 27.8424 119.605 27.9716 119.205 28.2308C118.736 28.5505 118.502 28.9562 118.502 29.4472C118.502 29.8336 118.64 30.1342 118.915 30.3472C119.19 30.559 119.521 30.666 119.905 30.666C120.493 30.666 120.945 30.3989 121.265 29.8616V30.0854C121.265 30.2628 121.282 30.3844 121.313 30.4466C121.347 30.5093 121.432 30.5421 121.569 30.5421H121.936C122.149 30.5421 122.255 30.4767 122.255 30.3493C122.255 30.2647 122.198 30.2055 122.081 30.1665C121.976 30.1305 121.908 30.0842 121.872 30.0289ZM120.061 28.3456C120.317 28.269 120.576 28.2311 120.839 28.2311L121.198 28.2442V28.9506C121.198 29.3725 121.092 29.6757 120.882 29.8619C120.643 30.0857 120.339 30.197 119.969 30.197C119.761 30.197 119.563 30.1129 119.376 29.9472C119.234 29.8237 119.164 29.6427 119.164 29.407C119.164 29.1277 119.249 28.9001 119.421 28.7235C119.593 28.5486 119.806 28.4223 120.061 28.3456Z",
    fill: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.763 29.8372C123.763 29.9491 123.783 30.0235 123.826 30.0578C123.87 30.0929 123.932 30.1249 124.013 30.1554C124.111 30.2077 124.158 30.2698 124.158 30.3369C124.158 30.4742 124.065 30.5438 123.881 30.5438H123.008C122.822 30.5438 122.73 30.4739 122.73 30.3369C122.73 30.2647 122.775 30.2077 122.862 30.1682C122.948 30.1423 123.016 30.1089 123.066 30.0701C123.115 30.0322 123.139 29.9548 123.139 29.8375V27.7773C123.139 27.4814 123.025 27.2728 122.798 27.1521C122.664 27.1073 122.597 27.0462 122.597 26.9731C122.597 26.8929 122.674 26.7967 122.824 26.6819C123.033 26.5061 123.181 26.4183 123.272 26.4183C123.411 26.4183 123.509 26.5188 123.564 26.7198C123.618 26.923 123.672 27.1863 123.723 27.5129C123.819 27.2603 123.974 27.016 124.184 26.7765C124.396 26.5376 124.606 26.418 124.82 26.418C125.127 26.418 125.28 26.5938 125.28 26.9452C125.28 27.1572 125.219 27.2631 125.097 27.2631C125.052 27.2631 124.973 27.2327 124.858 27.1735C124.744 27.1142 124.656 27.0842 124.593 27.0842C124.398 27.0842 124.2 27.2641 124.001 27.6243C123.841 27.8845 123.762 28.1833 123.762 28.5233L123.763 29.8372Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.94 26.6714C122.94 26.6714 122.94 26.6717 122.942 26.6723C122.94 26.6717 122.94 26.6714 122.94 26.6714Z",
    stroke: "black"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.742 29.8737C126.489 29.6682 126.331 29.3933 126.271 29.0486L126.429 29.0343C127.236 28.9327 127.79 28.8173 128.093 28.6866C128.754 28.4349 129.084 28.0421 129.084 27.5107C129.084 27.148 128.911 26.8621 128.568 26.6527C128.344 26.4953 128.066 26.416 127.736 26.416C127.34 26.416 126.976 26.5204 126.644 26.726C126.312 26.9345 126.051 27.2145 125.858 27.5687C125.667 27.9217 125.572 28.3032 125.572 28.7129C125.572 29.2791 125.758 29.7459 126.131 30.114C126.504 30.4813 126.96 30.666 127.5 30.666C127.928 30.666 128.319 30.5368 128.675 30.2776C129.017 30.0261 129.19 29.8051 129.19 29.6162C129.19 29.5155 129.142 29.4647 129.045 29.4647C128.994 29.4647 128.895 29.5352 128.752 29.6791C128.607 29.8212 128.453 29.9408 128.286 30.0384C128.119 30.1359 127.902 30.1839 127.632 30.1839C127.293 30.1839 126.996 30.0806 126.742 29.8737ZM128.422 27.4982C128.422 28.1625 127.696 28.5544 126.246 28.6732L126.216 28.6735C126.216 28.1603 126.344 27.726 126.599 27.3747C126.855 27.0213 127.221 26.8455 127.696 26.8455C127.911 26.8455 128.086 26.9006 128.22 27.0076C128.354 27.116 128.422 27.2796 128.422 27.4982Z",
    fill: "#333333"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-1_1_21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112 28H40V28.6H112V28Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112 28H40V28.6H112V28Z",
    fill: "#333333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112 28H113V27H112V28ZM40 28V27H39V28H40ZM40 28.6H39V29.6H40V28.6ZM112 28.6V29.6H113V28.6H112ZM112 27H40V29H112V27ZM39 28V28.6H41V28H39ZM40 29.6H112V27.6H40V29.6ZM113 28.6V28H111V28.6H113Z",
    fill: "black",
    mask: "url(#path-19-inside-1_1_21)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112 28H113V27H112V28ZM40 28V27H39V28H40ZM40 28.6H39V29.6H40V28.6ZM112 28.6V29.6H113V28.6H112ZM112 27H40V29H112V27ZM39 28V28.6H41V28H39ZM40 29.6H112V27.6H40V29.6ZM113 28.6V28H111V28.6H113Z",
    fill: "black",
    fillOpacity: 0.2,
    mask: "url(#path-19-inside-1_1_21)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_21",
    x: 118.597,
    y: 26.418,
    width: 10.683,
    height: 12.1258,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_21"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_21",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_21",
    x1: 5.83979,
    y1: 26.3947,
    x2: 23.9599,
    y2: 26.3947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_21",
    x1: 10.3359,
    y1: 31.1162,
    x2: 36.8916,
    y2: 31.1162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_21",
    x1: 11.2319,
    y1: 17.6023,
    x2: 16.7212,
    y2: 22.9118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#144470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1F6082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#307C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4187A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#205E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#164672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_21",
    x1: -4.58127,
    y1: 20.5748,
    x2: -2.09931,
    y2: 38.1382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#193758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#144470"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1F6082"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#307C9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#78AAB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4187A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#205E81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#164672"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#183758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_21",
    x1: 8.58087,
    y1: 22.183,
    x2: 3.26958,
    y2: 31.2619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_21",
    x1: 39.5996,
    y1: 22.639,
    x2: 45.8357,
    y2: 22.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_21",
    x1: 46.8068,
    y1: 22.4007,
    x2: 57.9661,
    y2: 22.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_21",
    x1: 58.4185,
    y1: 22.4179,
    x2: 72.6567,
    y2: 22.4179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_21",
    x1: 72.2994,
    y1: 22.5876,
    x2: 83.6531,
    y2: 22.5876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_21",
    x1: 84.5439,
    y1: 22.4369,
    x2: 91.071,
    y2: 22.4369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_21",
    x1: 93.4668,
    y1: 22.52,
    x2: 104.368,
    y2: 22.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_21",
    x1: 106.246,
    y1: 22.5034,
    x2: 117.714,
    y2: 22.5034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_21",
    x1: 118.199,
    y1: 22.4007,
    x2: 129.359,
    y2: 22.4007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1914,
    stopColor: "#293881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2642,
    stopColor: "#1736A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3113,
    stopColor: "#2643C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3881,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4016,
    stopColor: "#435CFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5148,
    stopColor: "#1038BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5876,
    stopColor: "#143098"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#1D2663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03043B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.37baff5fb73012adfb2848cbad7aa918.svg";
export { ForwardRef as ReactComponent };